// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__3x2bI","emails":"CreateEditClinics_emails__2IrVG","emailTagLabel":"CreateEditClinics_emailTagLabel__ZvyMv"};